<template>
	<vx-card :title="$t('Follower.TemplateSettings')" class="mt-2" id="template_name-settings">
		<p class="mb-base">{{ $t("Follower.TemplateSettingsText") }}</p>

		<label class="vs-input--label" for="template">{{ $t("Follower.SelectLanguageText") }}</label>

		<v-select
			class="w-full"
			v-model="language"
			:options="languages"
			:clearable="false"
			:closeOnSelect="true"
			value="language_value"
			label="label"
			name="language_value"
			id="language_value"
		/>

		<label class="vs-input--label" for="template">{{ $t("Follower.SelectTemplate") }}</label>

		<v-select
			class="w-full"
			v-model="template"
			:options="templates"
			:clearable="false"
			:closeOnSelect="true"
			value="template_name"
			label="label"
			name="template_name"
			id="template_name"
		/>

		<label class="vs-input--label text-danger" v-show="templateError && !template">{{
			$t("Follower.SelectTemplateError")
		}}</label>

		<p class="text-base mt-base">{{ $t("Follower.TemplateText") }}:</p>

		<vs-alert
			icon-pack="feather"
			icon="icon-message-square"
			color="success"
			:title="$t('Follower.Template')"
			:active="template !== null"
			class="mt-4"
		>
			{{ formattedMessage }}
		</vs-alert>

		<vs-alert icon-pack="feather" icon="icon-message-square" color="warning" :active="!template" class="mt-4">
			{{ $t("Follower.PleaseSelectTemplate") }}
		</vs-alert>
	</vx-card>
</template>

<script>
import Event from "@/models/Event";

import vSelect from "vue-select";

import moduleSchedule from "@/store/schedule/moduleSchedule.js";

export default {
	name: "FollowerForm",
	components: {
		// component components
		vSelect,
	},
	props: {
		follower: {
			type: Object,
			required: true,
		},
		event: {
			type: Object,
			required: true,
		},
		templateError: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			// component data
			template: null,
			dataEvent: new Event(this.event),
			formattedMessage: "",
			language: {label: this.$t("Languages.Spanish"), language_value: "es_MX"},
		};
	},
	computed: {
		// component computed properties
		templates() {
			const getTemplates = this.$store.getters["moduleSchedule/getTemplates"];
			if (getTemplates.length === 0) return [];
			return getTemplates
				.filter((t) => t.language === this.language.language_value)
				.map((t, index) => {
					return {
						...t,
						label: this.$t("Follower.Template") + " " + (index + 1),
					};
				});
		},
		languages() {
			return [
				{label: this.$t("Languages.Spanish"), language_value: "es_MX"},
				{label: this.$t("Languages.English"), language_value: "en"},
				{label: this.$t("Languages.Portuguese"), language_value: "pt_BR"},
			];
		},
	},
	methods: {
		// component methods
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},

		formatString(template, params) {
			return template.replace(/{}/g, () => this.dataEvent[params.shift()] || "URL".toUpperCase());
		},

		fillTemplate() {
			if (!this.template) return;
			this.$emit("templateSelected", this.template.template_name);
		},
	},

	watch: {
		// component watch properties
		template(val) {
			const {params, message} = val || {params: [], message: ""};
			this.formattedMessage = this.formatString(message, [...params]);
			this.$emit("templateSelected", val.template_name);
		},
		templates(val) {
			if (val.length > 0 && this.follower.template_name) {
				const findTemplate = val.find((t) => t.template_name === this.follower.template_name);
				if (findTemplate) this.template = findTemplate;
			}
		},

		"follower.template_name"(val) {
			if (val && this.templates.length > 0) {
				const findTemplate = this.templates.find((t) => t.template_name === val);
				if (findTemplate) this.template = findTemplate;
			}
		},
		"follower.language"(val) {
			if (val) {
				const findLanguage = this.languages.find((l) => l.language_value === val);
				if (findLanguage) this.language = findLanguage;
			}
		},
		language(val) {
			this.$emit("languageSelected", val.language_value);
		},
	},

	created() {
		// component created hook
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
	},
};
</script>

<style scoped>
/* component styles */
</style>
